import { useEffect, useState } from "react";

import { Flow, FlowVersion } from "src/api/flowTypes";
import { Modal } from "src/design-system/Modal";
import { SelectFlowAndVersion } from "src/SelectFlowPane/SelectFlowPane";

type FlowToolFlowSelectionModalProps = {
  open: boolean;
  onClose: () => void;
  onSelect: (flow: Flow, version: FlowVersion) => void;
};

export const FlowToolFlowSelectionModal: React.FC<
  FlowToolFlowSelectionModalProps
> = ({ open, onClose, onSelect }) => {
  const [selectedFlow, setSelectedFlow] = useState<Flow | null>(null);

  // Reset the modal state upon reopening
  useEffect(() => {
    if (open) {
      setSelectedFlow(null);
    }
  }, [open]);

  const handleSubmit = (selectedVersion: FlowVersion) => {
    if (selectedFlow) {
      onSelect(selectedFlow, selectedVersion);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>Select a Decision Flow</Modal.Header>
      <Modal.Content>
        <div className="flex h-[540px] flex-col">
          <SelectFlowAndVersion
            selectedFlow={selectedFlow}
            onFlowSelect={setSelectedFlow}
            onVersionSelect={handleSubmit}
          />
        </div>
      </Modal.Content>
    </Modal>
  );
};
